/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterNSmall = createReactComponent("letter-n-small", "IconLetterNSmall", [
  ["path", { d: "M10 16v-8l4 8v-8", key: "svg-0" }]
]);

export { IconLetterNSmall as default };
//# sourceMappingURL=IconLetterNSmall.js.map
